import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import type { IObjectType } from '../../../stores/model/metamodel/object_type';

/**
 * Check if an object has both a CREATE and END method.
 */
class ObjectAlphabetRuleCheck extends Check<IObjectType> {
  static description = 'Check create and end methods';

  check(): Report {
    this.report = new Report();

    let create: boolean | undefined,
      end = false;

    for(const m of this.element.methods) {
      if(m.type === 'CREATE') {
        create = true;
      } else if(m.type === 'END') {
        end = true
      }
    }

    if(create && end) {
      this.report.addMessage(MessageType.INFORMATION, 'Create and end method found', this, this.element);
    } else if(create) {
      this.report.addMessage(MessageType.WARNING, 'No end method found.', this, this.element);
    } else if(end) {
      this.report.addMessage(MessageType.WARNING, 'No create method found', this, this.element);
    } else {
      this.report.addMessage(MessageType.WARNING, 'No create and no end method found.', this, this.element);
    }

    return this.report;
  }

}

export default ObjectAlphabetRuleCheck;
